import { useState, useEffect } from "react";

const BASE = "https://support.gs-group.fr/api";
const h = () => ({ "Content-Type":"application/json", Authorization:"Bearer "+localStorage.getItem("nexo_token") });

const CATEGORIES = [
  { id:"alarme", lbl:"Alarme",  icon:"🚨", color:"#ef4444" },
  { id:"video",  lbl:"Vidéo",   icon:"📹", color:"#8b5cf6" },
  { id:"caisse", lbl:"Caisse",  icon:"🗄️", color:"#f59e0b" },
  { id:"reseau", lbl:"Réseau",  icon:"🌐", color:"#3b82f6" },
];

const TEMPLATES = {
  alarme: [
    { objet:"Piles faibles — intervention à prévoir",  priorite:"haute",   desc:"Le panneau de contrôle signale une tension basse sur les piles de secours. Vérifier et remplacer si nécessaire." },
    { objet:"Fausse alarme répétée",                   priorite:"haute",   desc:"Déclenchements intempestifs répétés. Diagnostiquer les zones concernées (capteur, vent, animal...)." },
    { objet:"Centrale d'alarme hors service",          priorite:"urgente", desc:"La centrale ne répond plus. Vérifier alimentation, fusible et connexion réseau." },
    { objet:"Capteur défaillant",                      priorite:"normale", desc:"Un ou plusieurs capteurs signalent une anomalie. Identifier et remplacer." },
    { objet:"Alarme ne se désactive pas",              priorite:"urgente", desc:"Le client ne parvient pas à désactiver l'alarme. Intervention urgente ou assistance à distance." },
    { objet:"Réinitialisation code d'alarme",          priorite:"basse",   desc:"Client souhaite réinitialiser son code d'accès ou de désactivation." },
  ],
  video: [
    { objet:"Caméra(s) hors ligne",                   priorite:"haute",   desc:"Une ou plusieurs caméras ne remontent plus d'image. Vérifier alimentation, câble et configuration réseau." },
    { objet:"Caméras pas à l'heure",                  priorite:"basse",   desc:"Décalage horaire visible sur les enregistrements. Reconfigurer NTP ou fuseau horaire à distance." },
    { objet:"Notice caméras demandée",                 priorite:"basse",   desc:"Le client souhaite obtenir la documentation technique de son système caméras." },
    { objet:"Accès distant impossible",                priorite:"normale", desc:"Le client ne peut plus visualiser les caméras depuis son smartphone ou PC. Vérifier DDNS, port forwarding, identifiants." },
    { objet:"Image floue ou noire",                    priorite:"normale", desc:"Qualité d'image dégradée. Nettoyer l'optique ou vérifier l'exposition et les réglages IR." },
    { objet:"Enregistrements manquants",               priorite:"normale", desc:"Des séquences vidéo sont absentes. Vérifier capacité disque, planning d'enregistrement et état du HDD." },
    { objet:"Réinitialisation mot de passe DVR/NVR",   priorite:"basse",   desc:"Le client a oublié son mot de passe d'accès. Procédure de reset à réaliser." },
  ],
  caisse: [
    { objet:"Caisse ne s'allume pas",                  priorite:"urgente", desc:"La caisse enregistreuse ne démarre pas. Vérifier alimentation, fusible et état du système." },
    { objet:"Imprimante ticket défaillante",           priorite:"haute",   desc:"Impression absente, partiellement lisible ou bourrage papier. Vérifier rouleau et tête thermique." },
    { objet:"Caisse bloquée / gelée",                  priorite:"urgente", desc:"L'interface est figée et ne répond plus. Forcer le redémarrage et analyser les logs." },
    { objet:"Erreur de connexion TPE",                 priorite:"haute",   desc:"Le terminal de paiement ne communique plus avec la caisse. Vérifier câble, protocole et configuration." },
    { objet:"Tiroir-caisse ne s'ouvre plus",          priorite:"haute",   desc:"Le tiroir-caisse électronique ne répond plus à la commande. Vérifier le câble RJ11 et le solénoïde." },
    { objet:"Mise à jour logicielle caisse",           priorite:"basse",   desc:"Demande de mise à jour du logiciel de caisse vers la dernière version disponible." },
  ],
  reseau: [
    { objet:"Perte connexion Internet",               priorite:"urgente", desc:"Le site n'a plus accès à Internet. Vérifier box, routeur, ONT/fibre et état opérateur." },
    { objet:"VPN défaillant",                         priorite:"haute",   desc:"Le tunnel VPN ne s'établit plus. Vérifier certificats, IP publique et règles firewall." },
    { objet:"Équipement réseau hors service",         priorite:"haute",   desc:"Switch ou routeur ne répond plus. Tester alimentation, remplacement éventuel." },
    { objet:"Réseau Wi-Fi instable",                  priorite:"normale", desc:"Déconnexions fréquentes ou signal faible. Analyser canaux, repositionner borne, vérifier interférences." },
  ],
};

const PRIO_COL = { urgente:"#ef4444", haute:"#f59e0b", normale:"#5b6ef8", basse:"#22d3a0" };

export default function ModalSAV({ T, onClose, onCreated }) {
  const [clients, setClients] = useState([]);
  const [techniciens, setTechniciens] = useState([]);
  const [saving, setSaving] = useState(false);
  const [geocoding, setGeocoding] = useState(false);
  const [error, setError] = useState("");
  const [geoOk, setGeoOk] = useState(false);
  const [step, setStep] = useState("category");
  const [category, setCategory] = useState(null);

  const [form, setForm] = useState({
    objet:"", description:"", priorite:"normale", source:"manual",
    client_id:"", technicien_id:"", ville:"", lat:null, lng:null,
    notify_open:true,
  });

  useEffect(()=>{
    fetch(`${BASE}/clients`,{headers:h()}).then(r=>r.json()).then(d=>setClients(Array.isArray(d)?d:[]));
    fetch(`${BASE}/users/techniciens`,{headers:h()}).then(r=>r.json()).then(d=>setTechniciens(Array.isArray(d)?d:[]));
  },[]);

  const up = (k,v) => setForm(p=>({...p,[k]:v}));

  const pickTemplate = (tpl) => {
    setForm(p=>({...p, objet:tpl.objet, priorite:tpl.priorite, description:tpl.desc}));
    setStep("form");
  };

  const selectClient = (clientId) => {
    const client = clients.find(c=>String(c.id)===String(clientId));
    setForm(p=>({
      ...p,
      client_id: clientId,
      ville: (client?.ville && !p.ville) ? client.ville : p.ville,
      notify_open: !!client?.email,
    }));
    if (client?.ville && !form.ville) geocodeVille(client.ville);
  };

  const geocodeVille = async (ville) => {
    if (!ville || ville.length < 3) return;
    setGeocoding(true); setGeoOk(false);
    try {
      const res = await fetch(
        `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(ville+", France")}&format=json&limit=1`,
        {headers:{"User-Agent":"GS-GROUP-CRM/1.0"}}
      ).then(r=>r.json());
      if (res[0]) { setForm(p=>({...p,lat:parseFloat(res[0].lat),lng:parseFloat(res[0].lon)})); setGeoOk(true); }
    } catch(e) {}
    setGeocoding(false);
  };

  const handleSubmit = async () => {
    if (!form.objet) { setError("L'objet est obligatoire"); return; }
    setSaving(true);
    const res = await fetch(`${BASE}/tickets`,{
      method:"POST", headers:h(),
      body: JSON.stringify({
        objet:form.objet, description:form.description, priorite:form.priorite,
        source:form.source, client_id:form.client_id||null, technicien_id:form.technicien_id||null,
        ville:form.ville||null, lat:form.lat||null, lng:form.lng||null,
        category, notify_open: form.notify_open && !!selectedClient?.email,
      })
    }).then(r=>r.json());
    setSaving(false);
    if (res.error) { setError(res.error); return; }
    onCreated();
  };

  const selectedClient = clients.find(c=>String(c.id)===String(form.client_id));
  const clientHasEmail = !!selectedClient?.email;

  // ── Step 1 : Catégorie ──────────────────────────────────────────
  if (step === "category") return (
    <div style={{position:"fixed",inset:0,background:"rgba(8,12,30,0.22)",backdropFilter:"blur(4px)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:16,animation:"nx-modal-open 0.3s cubic-bezier(0.16,1,0.3,1) both",width:480}}>
        <div style={{padding:"20px 24px 16px",borderBottom:`1px solid ${T.border}`,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div>
            <div style={{fontSize:18,fontWeight:800,color:T.text}}>🎫 Nouveau ticket SAV</div>
            <div style={{fontSize:12,color:T.muted,marginTop:3}}>Quel est le type de problème ?</div>
          </div>
          <button onClick={onClose} style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:22}}>✕</button>
        </div>
        <div style={{padding:"20px 24px",display:"flex",flexDirection:"column",gap:10}}>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
            {CATEGORIES.map(cat=>(
              <button key={cat.id} onClick={()=>{setCategory(cat.id);setStep("templates");}}
                style={{padding:"18px 14px",borderRadius:12,border:`2px solid ${T.border}`,background:T.bg,color:T.text,fontSize:14,fontWeight:600,cursor:"pointer",display:"flex",flexDirection:"column",alignItems:"center",gap:7,transition:"border-color 0.15s"}}
                onMouseEnter={e=>e.currentTarget.style.borderColor=cat.color}
                onMouseLeave={e=>e.currentTarget.style.borderColor=T.border}>
                <span style={{fontSize:30}}>{cat.icon}</span>
                <span>{cat.lbl}</span>
              </button>
            ))}
          </div>
          <button onClick={()=>{setCategory("autre");setStep("form");}}
            style={{padding:"12px",borderRadius:10,border:`1.5px dashed ${T.border}`,background:"transparent",color:T.muted,fontSize:13,fontWeight:600,cursor:"pointer"}}>
            ✏️ Autre / saisie libre
          </button>
        </div>
      </div>
    </div>
  );

  // ── Step 2 : Templates ──────────────────────────────────────────
  if (step === "templates") {
    const cat = CATEGORIES.find(c=>c.id===category);
    const tpls = TEMPLATES[category]||[];
    return (
      <div style={{position:"fixed",inset:0,background:"rgba(8,12,30,0.22)",backdropFilter:"blur(4px)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
        <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:16,animation:"nx-modal-open 0.3s cubic-bezier(0.16,1,0.3,1) both",width:520,maxHeight:"82vh",display:"flex",flexDirection:"column"}}>
          <div style={{padding:"20px 24px 16px",borderBottom:`1px solid ${T.border}`,display:"flex",justifyContent:"space-between",alignItems:"center",flexShrink:0}}>
            <div>
              <div style={{fontSize:18,fontWeight:800,color:T.text}}>{cat?.icon} {cat?.lbl} — Motif</div>
              <div style={{fontSize:12,color:T.muted,marginTop:3}}>Choisissez le motif du ticket</div>
            </div>
            <button onClick={onClose} style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:22}}>✕</button>
          </div>
          <div style={{flex:1,overflowY:"auto",padding:"16px 24px",display:"flex",flexDirection:"column",gap:8}}>
            {tpls.map((tpl,i)=>{
              const pc = PRIO_COL[tpl.priorite]||T.accent;
              return (
                <button key={i} onClick={()=>pickTemplate(tpl)}
                  style={{padding:"13px 16px",borderRadius:10,border:`1.5px solid ${T.border}`,background:T.bg,color:T.text,fontSize:13,fontWeight:500,cursor:"pointer",textAlign:"left",display:"flex",alignItems:"center",justifyContent:"space-between",gap:12,transition:"border-color 0.15s"}}
                  onMouseEnter={e=>e.currentTarget.style.borderColor=pc}
                  onMouseLeave={e=>e.currentTarget.style.borderColor=T.border}>
                  <span>{tpl.objet}</span>
                  <span style={{flexShrink:0,fontSize:11,fontWeight:700,color:pc,background:pc+"18",border:`1px solid ${pc}30`,borderRadius:20,padding:"2px 8px",textTransform:"capitalize"}}>{tpl.priorite}</span>
                </button>
              );
            })}
            <button onClick={()=>setStep("form")}
              style={{padding:"11px 16px",borderRadius:10,border:`1.5px dashed ${T.border}`,background:"transparent",color:T.muted,fontSize:13,fontWeight:600,cursor:"pointer",textAlign:"left"}}>
              ✏️ Saisie libre
            </button>
          </div>
          <div style={{padding:"12px 24px",borderTop:`1px solid ${T.border}`,flexShrink:0}}>
            <button onClick={()=>setStep("category")} style={{background:"none",border:"none",color:T.muted,fontSize:12,cursor:"pointer",padding:0}}>← Changer de catégorie</button>
          </div>
        </div>
      </div>
    );
  }

  // ── Step 3 : Formulaire ─────────────────────────────────────────
  const cat = CATEGORIES.find(c=>c.id===category);
  return (
    <div style={{position:"fixed",inset:0,background:"rgba(8,12,30,0.22)",backdropFilter:"blur(4px)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:16,animation:"nx-modal-open 0.3s cubic-bezier(0.16,1,0.3,1) both",width:540,maxHeight:"90vh",display:"flex",flexDirection:"column"}}>

        {/* Header */}
        <div style={{padding:"20px 24px 14px",borderBottom:`1px solid ${T.border}`,display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexShrink:0}}>
          <div>
            <div style={{fontSize:18,fontWeight:800,color:T.text}}>🎫 Nouveau ticket SAV</div>
            <div style={{marginTop:5,display:"flex",alignItems:"center",gap:6}}>
              {cat&&<span style={{fontSize:11,fontWeight:700,padding:"2px 9px",borderRadius:20,background:cat.color+"18",color:cat.color,border:`1px solid ${cat.color}30`}}>{cat.icon} {cat.lbl}</span>}
              <button onClick={()=>setStep(category&&TEMPLATES[category]?.length?"templates":"category")} style={{background:"none",border:"none",color:T.muted,fontSize:11,cursor:"pointer",padding:0}}>← Changer le motif</button>
            </div>
          </div>
          <button onClick={onClose} style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:22}}>✕</button>
        </div>

        {/* Content */}
        <div style={{flex:1,overflowY:"auto",padding:"16px 24px",display:"flex",flexDirection:"column",gap:13}}>
          {error&&<div style={{background:T.dangerDim,border:`1px solid ${T.danger}40`,borderRadius:9,padding:"10px 14px",fontSize:13,color:T.danger}}>⚠ {error}</div>}

          {/* Objet */}
          <div style={{display:"flex",flexDirection:"column",gap:5}}>
            <label style={{fontSize:11,fontWeight:700,color:T.mutedL,textTransform:"uppercase",letterSpacing:"0.5px"}}>Objet / Titre *</label>
            <input value={form.objet||""} onChange={e=>up("objet",e.target.value)} placeholder="Ex: Remplacement caméra défectueuse"
              style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:9,padding:"10px 13px",color:T.text,fontSize:14,outline:"none"}}/>
          </div>

          {/* Priorité */}
          <div style={{display:"flex",flexDirection:"column",gap:6}}>
            <label style={{fontSize:11,fontWeight:700,color:T.mutedL,textTransform:"uppercase",letterSpacing:"0.5px"}}>Priorité</label>
            <div style={{display:"flex",gap:8}}>
              {[["basse","🟢","#22d3a0"],["normale","🔵","#5b6ef8"],["haute","🟡","#f5a623"],["urgente","🔴","#ef4444"]].map(([p,ic,col])=>(
                <button key={p} onClick={()=>up("priorite",p)}
                  style={{flex:1,padding:"8px 4px",borderRadius:9,border:`2px solid ${form.priorite===p?col:T.border}`,background:form.priorite===p?col+"22":"transparent",color:form.priorite===p?col:T.muted,fontSize:12,fontWeight:700,cursor:"pointer",textTransform:"capitalize",transition:"all 0.15s"}}>
                  {ic} {p}
                </button>
              ))}
            </div>
          </div>

          {/* Source */}
          <div style={{display:"flex",flexDirection:"column",gap:5}}>
            <label style={{fontSize:11,fontWeight:700,color:T.mutedL,textTransform:"uppercase",letterSpacing:"0.5px"}}>Source</label>
            <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
              {[["manual","📋 Manuel"],["telephone","📞 Téléphone"],["email","📧 Email"],["web","🌐 Web"]].map(([s,l])=>(
                <button key={s} onClick={()=>up("source",s)}
                  style={{padding:"7px 13px",borderRadius:8,border:`1.5px solid ${form.source===s?T.accent:T.border}`,background:form.source===s?T.accentDim:"transparent",color:form.source===s?T.accent:T.muted,fontSize:12,fontWeight:form.source===s?700:500,cursor:"pointer"}}>
                  {l}
                </button>
              ))}
            </div>
          </div>

          {/* Client */}
          <div style={{display:"flex",flexDirection:"column",gap:5}}>
            <label style={{fontSize:11,fontWeight:700,color:T.mutedL,textTransform:"uppercase",letterSpacing:"0.5px"}}>Client</label>
            <select value={form.client_id||""} onChange={e=>selectClient(e.target.value)}
              style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:9,padding:"10px 13px",color:T.text,fontSize:14,outline:"none",cursor:"pointer"}}>
              <option value="">— Sans client —</option>
              {clients.map(c=><option key={c.id} value={c.id}>{c.raison_sociale||c.nom}{c.ville?` · ${c.ville}`:""}</option>)}
            </select>
          </div>

          {/* Notification toggle */}
          {form.client_id&&(
            <div style={{background:form.notify_open&&clientHasEmail?"rgba(16,185,129,0.06)":"rgba(245,158,11,0.05)",border:`1px solid ${form.notify_open&&clientHasEmail?"rgba(16,185,129,0.3)":"rgba(245,158,11,0.3)"}`,borderRadius:10,padding:"11px 14px",display:"flex",alignItems:"center",justifyContent:"space-between",gap:12}}>
              <div>
                <div style={{fontSize:13,fontWeight:700,color:T.text}}>📧 Notifier le client à l'ouverture</div>
                <div style={{fontSize:11,color:T.muted,marginTop:2}}>
                  {clientHasEmail ? `Email envoyé à ${selectedClient.email}` : "⚠ Pas d'email sur la fiche client"}
                </div>
              </div>
              <button onClick={()=>up("notify_open",!form.notify_open)} disabled={!clientHasEmail}
                style={{width:40,height:22,borderRadius:11,border:"none",cursor:clientHasEmail?"pointer":"not-allowed",position:"relative",background:form.notify_open&&clientHasEmail?"#10b981":"#cbd5e1",transition:"background 0.2s",flexShrink:0,opacity:clientHasEmail?1:0.45}}>
                <div style={{position:"absolute",top:2,left:form.notify_open&&clientHasEmail?18:2,width:18,height:18,borderRadius:"50%",background:"#fff",transition:"left 0.2s",boxShadow:"0 1px 3px rgba(0,0,0,0.2)"}}/>
              </button>
            </div>
          )}

          {/* Technicien */}
          <div style={{display:"flex",flexDirection:"column",gap:5}}>
            <label style={{fontSize:11,fontWeight:700,color:T.mutedL,textTransform:"uppercase",letterSpacing:"0.5px"}}>Technicien <span style={{fontWeight:400,textTransform:"none"}}>(optionnel)</span></label>
            <select value={form.technicien_id||""} onChange={e=>up("technicien_id",e.target.value)}
              style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:9,padding:"10px 13px",color:T.text,fontSize:14,outline:"none",cursor:"pointer"}}>
              <option value="">— Non assigné —</option>
              {techniciens.map(t=><option key={t.id} value={t.id}>{t.prenom} {t.nom}</option>)}
            </select>
          </div>

          {/* Ville */}
          <div style={{display:"flex",flexDirection:"column",gap:5}}>
            <label style={{fontSize:11,fontWeight:700,color:T.mutedL,textTransform:"uppercase",letterSpacing:"0.5px"}}>
              📍 Ville / Adresse
              {geocoding&&<span style={{color:T.accent,fontWeight:400,marginLeft:8}}>⏳ Géocodage...</span>}
              {geoOk&&!geocoding&&<span style={{color:T.success,fontWeight:400,marginLeft:8}}>✅ Géolocalisé</span>}
            </label>
            <div style={{display:"flex",gap:8}}>
              <input value={form.ville||""} onChange={e=>{up("ville",e.target.value);setGeoOk(false);}}
                onKeyDown={e=>e.key==="Enter"&&geocodeVille(form.ville)}
                placeholder="Ex: Mulhouse, Belfort..." style={{flex:1,background:T.bg,border:`1.5px solid ${geoOk?T.success:T.border}`,borderRadius:9,padding:"10px 13px",color:T.text,fontSize:14,outline:"none"}}/>
              <button onClick={()=>geocodeVille(form.ville)} disabled={!form.ville||geocoding}
                style={{padding:"10px 14px",borderRadius:9,background:T.accentDim,border:`1px solid ${T.accent}40`,color:T.accent,fontSize:13,fontWeight:700,cursor:"pointer",flexShrink:0}}>
                {geocoding?"⏳":"📍"}
              </button>
            </div>
          </div>

          {/* Description */}
          <div style={{display:"flex",flexDirection:"column",gap:5}}>
            <label style={{fontSize:11,fontWeight:700,color:T.mutedL,textTransform:"uppercase",letterSpacing:"0.5px"}}>Description interne</label>
            <textarea value={form.description||""} onChange={e=>up("description",e.target.value)} rows={3}
              placeholder="Notes pour l'équipe technique..."
              style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:9,padding:"10px 13px",color:T.text,fontSize:13,outline:"none",resize:"vertical",lineHeight:1.6}}/>
          </div>
        </div>

        {/* Footer */}
        <div style={{padding:"14px 24px",borderTop:`1px solid ${T.border}`,display:"flex",gap:10,flexShrink:0}}>
          <button onClick={onClose} style={{flex:1,padding:"11px",borderRadius:10,border:`1px solid ${T.border}`,background:"transparent",color:T.muted,fontSize:14,fontWeight:600,cursor:"pointer"}}>Annuler</button>
          <button onClick={handleSubmit} disabled={saving||!form.objet}
            style={{flex:2,padding:"11px",borderRadius:10,background:form.objet?`linear-gradient(135deg,${T.accent},${T.purple})`:T.border,border:"none",color:"#fff",fontSize:14,fontWeight:700,cursor:form.objet?"pointer":"not-allowed",opacity:saving?0.7:1}}>
            {saving?"Création en cours...":(form.notify_open&&clientHasEmail?"✅ Créer et notifier le client":"✅ Créer le ticket SAV")}
          </button>
        </div>
      </div>
    </div>
  );
}
